import EventEmitter from 'src/libs/EventEmitter';
import domSelector from 'src/utils/domSelector';

import optionHandlers from './optionHandlers';

const COMPLETED_EVENT = 'COMPLETED_EVENT';
const CHANGED_EVENT = 'CHANGED_EVENT';

const destroy = function() {
  /*
    this is declared here separately in order to be able to unit test it.
    for unknown reasons, `View.prototype.destroy` is not getting reset after it gets mocked in our units tests.
    It gets mocked in our view specs, which call this through `super.destroy`
  */
  Array.from(this.body.children).forEach((child) => child.remove());
};

export default class View extends EventEmitter {
  constructor() {
    super({ type: 'View', color: '#284B7C' });
    this.body = domSelector.getPPFBody();
    this.domSelector = domSelector;
    this.optionHandlers = optionHandlers;
  }

  appendToBody(template) {
    const container = document.createElement('div');
    this.body.appendChild(container);
    container.outerHTML = template;
  }

  emitCompleted(data) {
    this.emit(COMPLETED_EVENT, data);
  }

  addCompletedListener(fn) {
    this.on(COMPLETED_EVENT, fn);
  }

  removeCompletedListener(fn) {
    this.off(COMPLETED_EVENT, fn);
  }

  emitChange(data) {
    this.emit(CHANGED_EVENT, data);
  }

  addChangeListener(fn) {
    this.on(CHANGED_EVENT, fn);
  }

  removeChangeListener(fn) {
    this.off(CHANGED_EVENT, fn);
  }

  destroy() {
    destroy.call(this);
  }
}

